import { Neutral, Semantic, Warning } from '../typings'

export const success: Semantic = {
  5: '#EFF6EF',
  70: '#007000',
}

export const warning: Warning = {
  5: '#FEF9EA',
  70: '#F5B700',
  90: '#826100',
}

export const error: Semantic = {
  5: '#FCF0F0',
  70: '#C40000',
}

export const info: Semantic = {
  5: '#EEF4FF',
  70: '#224AA0',
}

export const neutral: Neutral = {
  0: '#fff',
  5: '#fafafa',
  10: '#f3f3f3',
  20: '#e5e5e6',
  30: '#cbcccd',
  40: '#b1b2b4',
  50: '#929496',
  60: '#7d7f81',
  70: '#6d6f70',
  80: '#4b4d4f',
  90: '#3d3c38',
  100: '#212223',
  110: '#19191a',
  120: '#000',
  140: '#1976D2',
}
